// Path helpers in initialization use token: :token → "/api/v1/challenge_invites/token" (literal segment).
export function replaceChallengeInviteToken(endpoint, token) {
	const encoded = encodeURIComponent(token);
	return String(endpoint || '')
		.replace('/token/accept', `/${encoded}/accept`)
		.replace('/token/decline', `/${encoded}/decline`)
		.replace('/token', `/${encoded}`);
}

async function fetchCsrfToken() {
	const response = await fetch('/csrf-token');
	const data = await response.json();
	return data.csrfToken;
}

export async function fetchChallengeInvite({ token, endpoint }) {
	const url = replaceChallengeInviteToken(endpoint, token);
	const response = await fetch(url);
	const data = await response.json();

	if (!response.ok || !data.success) {
		throw new Error(data.error || (data.errors || []).join(' ') || 'Could not load challenge invite.');
	}

	return data.data;
}

export async function respondToChallengeInvite({ token, endpoint, action }) {
	const url = replaceChallengeInviteToken(endpoint, token);
	const csrfToken = await fetchCsrfToken();
	const response = await fetch(url, {
		method: 'PATCH',
		headers: {
			'Content-Type': 'application/json',
			'X-CSRF-Token': csrfToken
		},
		body: JSON.stringify({ action })
	});
	const data = await response.json();

	if (!response.ok || !data.success) {
		throw new Error((data.errors || []).join(' ') || data.error || 'Could not update challenge.');
	}

	return data;
}
